import React, { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { 
  BuildingOfficeIcon,
  PhoneIcon,
  EnvelopeIcon,
  ClockIcon,
  DocumentIcon
} from '@heroicons/react/24/outline';
import { useClientStore } from '../store/clientStore';
import clsx from 'clsx';

export function ClientDetail() {
  const { id } = useParams();
  const { selectedClient, setSelectedClient } = useClientStore();

  useEffect(() => {
    if (id) {
      setSelectedClient(parseInt(id));
    }
  }, [id, setSelectedClient]);

  if (!selectedClient) {
    return <Navigate to="/clients" replace />;
  }

  return (
    <div className="space-y-6">
      <div className="bg-gray-800 rounded-lg p-6">
        <div className="flex items-center gap-4">
          <div className="text-5xl">{selectedClient.logo}</div>
          <div>
            <h1 className="text-2xl font-bold text-white mb-2">{selectedClient.name}</h1>
            <p className="text-gray-400">{selectedClient.industry}</p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-gray-800 rounded-lg p-6">
          <h2 className="text-lg font-semibold text-white mb-4 flex items-center">
            <BuildingOfficeIcon className="h-5 w-5 text-red-500 mr-2" />
            Contact Information
          </h2>
          <div className="space-y-3">
            <p className="flex items-center text-gray-300">
              <BuildingOfficeIcon className="h-5 w-5 text-gray-400 mr-2" />
              {selectedClient.contactName}
            </p>
            <p className="flex items-center text-gray-300">
              <EnvelopeIcon className="h-5 w-5 text-gray-400 mr-2" />
              {selectedClient.contactEmail}
            </p>
            <p className="flex items-center text-gray-300">
              <PhoneIcon className="h-5 w-5 text-gray-400 mr-2" />
              {selectedClient.contactPhone}
            </p>
          </div>
        </div>

        <div className="bg-gray-800 rounded-lg p-6">
          <h2 className="text-lg font-semibold text-white mb-4 flex items-center">
            <ClockIcon className="h-5 w-5 text-red-500 mr-2" />
            Payment Information
          </h2>
          <div className="space-y-3">
            <p className="text-gray-300">
              Payment Terms: {selectedClient.paymentTerms}
            </p>
          </div>
        </div>
      </div>

      <div className="bg-gray-800 rounded-lg p-6">
        <h2 className="text-lg font-semibold text-white mb-4 flex items-center">
          <DocumentIcon className="h-5 w-5 text-red-500 mr-2" />
          Projects
        </h2>
        <div className="space-y-4">
          {selectedClient.projects.map(project => (
            <div key={project.id} className="flex items-center justify-between p-4 bg-gray-750 rounded-lg">
              <div>
                <h3 className="text-white font-medium">{project.name}</h3>
                <p className="text-sm text-gray-400">
                  {project.startDate} - {project.endDate}
                </p>
              </div>
              <span className={clsx(
                'px-3 py-1 text-sm font-medium rounded-full',
                project.status === 'Completed' ? 'bg-green-100 text-green-800' :
                project.status === 'In Progress' ? 'bg-blue-100 text-blue-800' :
                'bg-yellow-100 text-yellow-800'
              )}>
                {project.status}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}